/**
 * Default one-way pickup selection from the a2a location text.
 *
 * `?oneway=true&city=Kuopio` reaches VehicleSearch through an asynchronous geocode: the
 * one-way routes and the geocoded location arrive in either order, so the decision has to
 * be re-run when the second one lands. Keeping it pure lets both call sites share it and
 * lets the ordering be tested without mounting the 1,900-line form.
 */
export const NO_PICKUP_MATCH = 'NO_MATCH';

export type PickupMatch = string | typeof NO_PICKUP_MATCH | undefined;

/** The city before the first comma of the location text, if it is a one-way pickup city. */
export function matchLocationToOneWayCity(
    locationText: string | undefined | null,
    routes: Record<string, unknown> | undefined | null,
): PickupMatch {
    const cities = Object.keys(routes ?? {});
    if (!cities.length) return undefined; // routes not loaded yet — decide later, not "no match"
    const text = (locationText ?? '').trim();
    if (!text) return undefined;
    const city = text.split(',')[0].trim();
    return cities.includes(city) ? city : NO_PICKUP_MATCH;
}

/**
 * The link's city wins over a pickup restored from the session, whichever of the geocode and the
 * routes lands first — but only once: a pickup the customer chooses after it was applied stays.
 */
export function shouldAutoSelectPickup(currentPickupValue: string | undefined, match: PickupMatch, lastApplied: string | undefined): match is string {
    return !!match && match !== NO_PICKUP_MATCH && match !== currentPickupValue && match !== lastApplied;
}
